import {
  DiMaDetailsContent,
  DiMaDetailsContentProps,
} from "../../../../components/DiMaDetailsContent"
import { RoleRequestGet } from "../../../../models/RoleRequest"
import { getNiceFormattedDate } from "../../../../utils/getFormattedDate"

export function RoleRequestHistory(props: { readonly roleRequest: RoleRequestGet }) {
  const { roleRequest } = props

  const detailsContentProps: DiMaDetailsContentProps = {
    listItems: [
      {
        id: 0,
        label: "Completion Date",
        displayItem: (
          <div style={{ width: "100%" }}>
            {roleRequest.completionDate
              ? getNiceFormattedDate(roleRequest.completionDate)
              : "Not completed yet"}
          </div>
        ),
      },
      {
        id: 1,
        label: "Creation Date",
        displayItem: (
          <div style={{ width: "100%" }}>
            {getNiceFormattedDate(roleRequest.creationDate)}
          </div>
        ),
      },
    ],
  }

  return <DiMaDetailsContent {...detailsContentProps} />
}
